import * as React from 'react';
import { Image, StyleSheet, Text } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { More } from "./More";
import { About } from "./About";
import { FAQ } from "./FAQ";
import { Learn } from "./Learn";
import { Credits } from "./Credits";
import { PrivacyPolicy } from "./PrivacyPolicy";
import { Policies } from "./Policies";
import { Terms } from "./Terms";
import { Debug } from "./Debug";
import { SuggestLocation } from "./SuggestLocation";
import { ListLocationsNear } from "./ListLocationsNear";
import { Contact } from "./Contact";
import { Subscribe } from "./Subscribe";
import { News } from "./News";
import { Test } from "./Test";
import { AllProducts } from "./AllProducts";
import { AllProducers } from "./AllProducers";
import { ProductDetails } from "./ProductDetails";
import { Filter } from "./Filter";
import { LocationDetails } from "./LocationDetails";
import * as AppConstants from "../context/AppConstants";
import * as AppUtilities from "../context/AppUtilities";
import { AppContext } from "../context/AppContext";
import { HeaderLeft } from '../components/HeaderLeft';
import { useSelector, useDispatch } from 'react-redux';
import { FilterSlider } from '../components/FilterSlider';

const styles = StyleSheet.create({
  mainImage: {
    width: 224,
    height: 38,
  },
});

const Stack = createNativeStackNavigator();

export function MoreStack() {
  const showFilterSlider = useSelector((state) => state.showFilterSlider);

  let mainImage = <Image source={require('../../assets/logo.png')} style={styles.mainImage} />;
  if (AppUtilities.isWeb()) {
    mainImage = <a href="/">{mainImage}</a>;
  }

  return (
    <Stack.Navigator
      screenOptions={({ navigation, route }) => ({
        headerRight: AppUtilities.getHeaderRight(navigation),
        headerTitle: (props) => <></>,
        detachPreviousScreen: false,
        animationEnabled: false,
        headerBackVisible: false,
        headerBackTitleVisible: false,
      })}
    >
      <Stack.Screen
        name={AppConstants.SCREENS.MORE}
        component={More}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} forceNoBackButton={true} noFiltersRight={true}>{mainImage}</HeaderLeft>,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.FILTER}
        component={Filter}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Filter" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_SUGGEST_LOCATION}
        component={SuggestLocation}
        options={({ navigation, route }) => ({
          headerLeft: ({ children, ...props }) => <HeaderLeft navigation={navigation} title="Suggestion Location" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_LIST_LOCATIONS_NEAR}
        component={ListLocationsNear}
        options={({ navigation, route }) => ({
          headerLeft: ({ children, ...props }) => <HeaderLeft navigation={navigation} title="List Locations" noFiltersRight={true} />,
          //headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.FAQ}
        component={FAQ}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="FAQ" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.LEARN}
        component={Learn}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Learn More" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.CREDITS}
        component={Credits}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Credits" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_CONTACT}
        component={Contact}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Contact Us" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_SUBSCRIBE}
        component={Subscribe}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Subscribe" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_ABOUT}
        component={About}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="About" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_TERMS}
        component={Terms}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Terms of Use" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_PRIVACY}
        component={PrivacyPolicy}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Privacy Policy" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_POLICIES}
        component={Policies}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Policies" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_DEBUG}
        component={Debug}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Diagnostics" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_NEWS}
        component={News}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="News" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.MORE_TEST}
        component={Test}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Test" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.ALL_PRODUCTS}
        component={AllProducts}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="All Products" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.ALL_PRODUCERS}
        component={AllProducers}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="All Producers" noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.PRODUCTS_ALL_DETAILS}
        component={ProductDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." noFiltersRight={true} />,
        })}
      />
      <Stack.Screen
        name={AppConstants.SCREENS.LOCATION_LIST_DETAILS}
        component={LocationDetails}
        options={({ navigation, route }) => ({
          headerLeft: (props) => <HeaderLeft navigation={navigation} title="Loading..." />,
          headerRight: () => showFilterSlider ? <FilterSlider vertical={false} /> : null,
        })}
      />
    </Stack.Navigator>
  );
}
